import SubscribeModalConfirm from './subscribe-modal-confirm';
import retail from 'components/retailrocket';
import metrikaCollector, {collectYandexReachGoal} from 'components/metrika';

export default function Subscribe($element) {
    if (!$element) {
        return;
    }

    if ($element._subscribe) {
        return $element._subscribe;
    }
    $element._subscribe = this;

    this._init = function() {
        this._$element = $element;
        this._$form = this._$element.querySelector('form');

        this._$submit = this._$form.elements['submit'];
        this._fields = [
            this._$form.elements['email'],
        ];
        this._$form.addEventListener('submit', this._onSubmit.bind(this));
        this._$form.addEventListener('change', this._onChange.bind(this));

        this._fields.forEach(($field) => {
            $field.addEventListener('focus', this.resetErrors.bind(this));
        });

        this._$element.classList.add('is-initialized');
    };

    this.resetErrors = function() {
        this._fields.forEach($field => $field.classList.remove('is-error'));
    };

    this.showErrors = function(fields = []) {
        for (let name in fields) {
            if (this._$form?.elements[name]) {
                this._$form?.elements[name].classList.add('is-error');

                const errorEl = this._$form?.querySelector(`[name="${name}"] ~ .Form__input-error`);
                if (errorEl) {
                    errorEl.textContent = fields[name];
                }
            }
        }
    }

    this.setLoading = function(isBlocked) {
        if (isBlocked) {
            this._$submit.classList.add('is-loading');
        } else {
            this._$submit.classList.remove('is-loading');
        }
    };

    /**
     * Событие отправки формы
     * @param {Event} e Событие
     */
    this._onSubmit = function(e) {
        e.preventDefault();

        const email = this._$form?.elements['email']?.value;
        const subs_place = this._$form?.elements['subs_place']?.value;

        this.resetErrors();
        this.setLoading(true);

        const subscribeGoals = {
            footer_subscription: 'subscribe_footer',
            main_banner_subscription: 'subscribe_main_banner',
            blog_banner_subscription: 'subscribe_blog_banner',
        };
        const subscribeGoal = subscribeGoals[subs_place];

        if (subscribeGoal && typeof yaCounter46243086 !== 'undefined') {
            yaCounter46243086.reachGoal(subscribeGoal);
            collectYandexReachGoal(metrikaCollector, subscribeGoal);
        }

        // сохраняем данные в профайл ритейла
        retail.setProfile({
            email,
            // isAgreedToReceiveMarketingMail: this._$form.elements['mail-ads-agreement']?.checked,
            isAgreedToReceiveMarketingMail: false, // потому что ставится true с double-opt письма после перехода
            customData: {
                [subs_place]: true,
            }
        });

        fetch('/subscribe/send/', {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: new FormData(this._$form)
        })
        .then((r) => r.json())
        .then((r) => {
            if (r.status === 'error') {
                return this.showErrors(r.fields);
            }

            // модалка подтверждения
            (new SubscribeModalConfirm()).open();
        })
        .finally(() => {
            this.setLoading(false);
        });
    };

    /**
     * Событие изменения формы
     * @param {Event} e Событие
     */
    this._onChange = function (e) {
        this._$submit.disabled = false;

        // стоит чекбокс и че то ввели
        if (!this._$form.elements['mail-ads-agreement'].checked || this._$form.elements['email'].value.length < 3) {
            this._$submit.disabled = true;
        }
    };

    this._init();
}
